<style lang="less">
.tip-view {
  justify-content: center;
  align-items: center;
  color: #666;
  text-align: center;
  display: flex;
  flex-direction: column;
  label {
    font-size: 20px;
  }
}
</style>

<template>
  <div class="login-container">
    <div class="login-container__admin">
      <a-form ref="loginForm" :form="form" class="login-form" auto-complete="on" label-position="left">
        <div v-if="resetStatus != 3" class="title-container">
          <h3 class="title">重置密码</h3>
        </div>
        <div v-if="resetStatus == 1">
          <a-form-item prop="account">
            <a-input size="large" type="text" placeholder="请输入邮箱地址" @keydown="" v-decorator="[
                'account',
                {rules: [{ required: true, message: '请输入邮箱地址' }, {type: 'email', message:'请输入正确的邮箱'}], validateTrigger: 'change'}
              ]">
              <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>
          <a-button :loading="loading" type="primary" class="green-btn" style="width:100%;margin-bottom:30px;" @click.native.prevent="sendEmail">下一步</a-button>
        </div>

        <div v-else-if="resetStatus == 2">
          <a-form-item prop="password">
            <a-input size="large" type='number' :autocomplete="false" placeholder="请输入验证码" v-decorator="[
                  'code',
                  {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: ['blur', 'change']}
                ]">
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-item>

          <a-form-item prop="password">
            <a-input size="large" :type="passwordType" autocomplete="false" placeholder="请输入新密码" v-decorator="[
                  'password',
                  {rules: [{ required: true, message: '请输入新密码' }], validateTrigger: ['blur', 'change']}
                ]">
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
              <a-icon v-if="passwordType" slot="suffix" type="eye" @click="showPwd" />
              <a-icon v-else slot="suffix" type="eye-invisible" @click="showPwd" />
            </a-input>
          </a-form-item>

          <a-form-item prop="password2">
            <a-input size="large" :type="passwordType" autocomplete="false" placeholder="请再次输入新密码" v-decorator="[
                  'password2',
                  {rules: [{ validator: passwordIsSame }], validateTrigger: ['blur', 'change']}
                ]">
              <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
              <a-icon v-if="passwordType" slot="suffix" type="eye" @click="showPwd" />
              <a-icon v-else slot="suffix" type="eye-invisible" @click="showPwd" />
            </a-input>
          </a-form-item>
          <a-button :loading="loading" type="primary" class="green-btn" style="width:100%;margin-bottom:30px;" @click.native.prevent="resetPassword">重置</a-button>
        </div>
        <div v-else class="tip-view">
          <a-icon style="margin-right:10px; font-size:60px;" type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
          <label style="margin-top:30px">{{ redirect_url ? '密码重置成功,自动返回' : "密码重置成功" }}</label>
          <a-button v-if="redirect_url" :loading="loading" type="primary" class="green-btn" style="margin-top:30px;" @click.native.prevent="goback">立即返回</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      resetStatus: 1,
      password: false,
      loading: false,
      redirect_url: '',
      saveSendEmail: '',
      passwordType: 'password',
      form: this.$form.createForm(this),

    }
  },
  created() {
    const parameter = this.getRequest(window.location.href)
    if (parameter.redirect_url) this.redirect_url = parameter.redirect_url
  },
  methods: {
    passwordIsSame(rules, value, callback) {
      const password = this.form.getFieldValue('password')
      const password2 = this.form.getFieldValue('password2')
      if (!password2) {
        callback('请再次输入新密码')
      }
      if (password != password2) {
        callback('两次密码不一致')
      }
      callback()
    },

    sendEmail() {
      this.form.validateFields(async (err, values) => {
        if (values.account) {
          try {
            this.loading = true
            this.saveSendEmail = values.account
            const data = await this.$store.dispatch('auth/sendEmailCode', { account: values.account })
            this.resetStatus = 2
            this.$message.success(`验证码已发送到邮箱`)
          } finally {
            this.loading = false
          }
        }
      })
    },
    resetPassword() {
      this.form.validateFields(async (err, values) => {
        const account = this.saveSendEmail
        const password = values.password == values.password ? values.password : ''
        const code = values.code
        if (account && password && code) {
          try {
            this.loading = true
            const data = await this.$store.dispatch('auth/resetPassword', { account, password, code })
            this.resetStatus = 3
            this.$message.success(`重置密码成功`)
            const self = this
            setTimeout(() => {
              self.goback()
            }, 1000);
          } finally {
            this.loading = false
          }
        }
      })
    },
    goback() {
      if (!this.redirect_url) return
      window.location.href = this.redirect_url
    },
    showPwd() {
      this.passwordType = this.passwordType ? '' : 'password'
    },

    getRequest(url) {
      var theRequest = new Object()
      if (!url) return
      if (url.indexOf("?") != -1) {
        var str = url.substr(url.indexOf("?") + 1)
        const strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest
    },
  }
}
</script>
